module.exports = __webpack_public_path__ + "std/img/red-packet-time.b0d7dd9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/red-packet-time.gif
// module id = ahB+
// module chunks = 0 10